import { useState } from "react";
import { Box } from "@mui/material";

export default function ColorPicker({ value, onChange, name, labelText }) {
  const [editing, setEditing] = useState(false);
  const isValidHex = /^#[0-9a-fA-F]{6}$/.test(value ?? "");
  const safeColor = isValidHex ? value : "#000000";

  return (
    <Box className="flex flex-col gap-1">
      {labelText && (
        <label className="text-xs">
          <b>{labelText}</b>
        </label>
      )}
      <Box className="flex gap-1 items-center">
        <input
          value={safeColor}
          onChange={onChange}
          name={name}
          type="color"
          style={{
            border: "none",
            outline: "none",
            width: 30,
            cursor: "pointer",
            borderRadius: "40px",
          }}
        />
        {editing ? (
          <input
            type="text"
            name={name}
            value={value ?? ""}
            onChange={onChange}
            onBlur={() => setEditing(false)}
            onKeyDown={(e) => {
              if (e.key === "Enter") setEditing(false);
            }}
            autoFocus
            maxLength={7}
            className="text-xs"
            style={{
              width: 74,
              border: "1px solid #ccc",
              borderRadius: 4,
              padding: "2px 4px",
              outline: "none",
            }}
          />
        ) : (
          <label
            className="text-xs"
            style={{ cursor: "pointer" }}
            title={value}
            onClick={() => setEditing(true)}
          >
            {value}
          </label>
        )}
      </Box>
    </Box>
  );
}
